import React from 'react';
import { requireNamespaces } from '~/locale/i18n';
import AccountGetsMarriedRedirectWrapper from '../../../components/AccountGetsMarried';

export const accountGetsMarried = (context: any, params: any) => {
  return {
    chunks: ['accountGetsMarried'],

    component: <AccountGetsMarriedRedirectWrapper context={context} params={params} />,
    ...requireNamespaces('membership', 'common', 'account'),
  };
};

if (module.hot) {
  module.hot.accept();
}
